// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductContextModel | ProductModel | CartLineModel;
}

type Props = OwnProps;

export interface ProductAddedToCartEnhancedMessageStyles {
    successToastContainer?: GridContainerProps;
    successToastProductImageGridItem?: GridItemProps;
    successToastProductImage?: ProductImageStyles;
    successToastProductDescriptionGridItem?: GridItemProps;
    successToastProductDescription?: ProductDescriptionStyles;
    successToastMessage?: TypographyProps;
}

export const productAddedToCartEnhancedMessageStyles: ProductAddedToCartEnhancedMessageStyles = {
    successToastContainer: {
        gap: 0,
    },
    successToastMessage: {
        color: "success",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            white-space: pre;
        `,
    },
    successToastProductDescriptionGridItem: {
        width: 9,
        css: css`
            padding-left: ${pxToRem(18)};
            align-items: center;
        `,
    },
    successToastProductImageGridItem: {
        width: 3,
        css: css`
            display: block;
        `,
    },
    successToastProductImage: {
        linkWrappingImage: {
            css: css`
                max-height: ${pxToRem(100)};
            `,
        },
    },
};

const styles = productAddedToCartEnhancedMessageStyles;

const ProductAddedToCartEnhancedMessage = ({ product }: Props) => {
    return (
        <>
            <GridContainer {...styles.successToastContainer}>
                <GridItem {...styles.successToastProductImageGridItem}>
                    <ProductImage
                        product={product as ProductContextModel}
                        showSmallImage={true}
                        extendedStyles={styles.successToastProductImage}
                    />
                </GridItem>
                <GridItem {...styles.successToastProductDescriptionGridItem}>
                    <ProductDescription
                        product={product as ProductContextModel}
                        extendedStyles={styles.successToastProductDescription}
                    />
                </GridItem>
            </GridContainer>
            <Typography {...styles.successToastMessage}>
                {translate("Has successfully been added to your cart")}
            </Typography>
        </>
    );
};

export default ProductAddedToCartEnhancedMessage;
